import { FollowUpType } from "models/appointment";
import { Translations } from "translations/types";

export type BookingFlowPaymentDueSummary = {
    dueNowLabel: string;
    dueAtClinicLabel: string;
    /** Whole dollars charged online today (for CTA copy). */
    dueNowDollars: number;
    showPaymentMethods: boolean;
    showClinicAcknowledgment: boolean;
};

function formatDueNowZero(language: string): string {
    return language === "fr" ? "0$" : "$0";
}

function formatDueNowAmount(language: string, dollars: number): string {
    return language === "fr" ? `${dollars}$` : `$${dollars}`;
}

export function getPublicBookingFlowDueSummary(
    followUpType: FollowUpType,
    language: string,
    publicCopy: Translations["upfrontPaymentSection"]["public"]
): BookingFlowPaymentDueSummary {
    if (followUpType === FollowUpType.Express) {
        return {
            dueNowLabel: formatDueNowAmount(language, 55),
            dueAtClinicLabel: publicCopy.expressTransportFeeAmount,
            dueNowDollars: 55,
            showPaymentMethods: true,
            showClinicAcknowledgment: true,
        };
    }

    return {
        dueNowLabel: formatDueNowZero(language),
        dueAtClinicLabel: publicCopy.transportFeeAmount,
        dueNowDollars: 0,
        showPaymentMethods: true,
        showClinicAcknowledgment: true,
    };
}

export function getPrivateBookingFlowDueSummary(
    language: string,
    dueAtClinicLabel: string
): BookingFlowPaymentDueSummary {
    return {
        dueNowLabel: formatDueNowAmount(language, 55),
        dueAtClinicLabel,
        dueNowDollars: 55,
        showPaymentMethods: true,
        showClinicAcknowledgment: true,
    };
}

export function getHpvBookingFlowDueSummary(
    hpvCopy: Translations["upfrontPaymentSection"]["hpv"]
): BookingFlowPaymentDueSummary {
    return {
        dueNowLabel: hpvCopy.consultationPrice,
        dueAtClinicLabel: hpvCopy.analysisPrice,
        dueNowDollars: 55,
        showPaymentMethods: true,
        showClinicAcknowledgment: true,
    };
}

export function isBookingFlowZeroDueNowPayment(
    dueSummary: BookingFlowPaymentDueSummary
): boolean {
    return dueSummary.showPaymentMethods && dueSummary.dueNowDollars <= 0;
}

export function getBookingFlowPayButtonLabel(
    language: string,
    dueNowDollars: number,
    confirmLabel: string,
    payPrefix: string
): string {
    if (dueNowDollars <= 0) {
        return confirmLabel;
    }
    const amount = formatDueNowAmount(language, dueNowDollars);
    return `${payPrefix} ${amount}`;
}
